import Icon from '../atomic/Icon'
import LazyLoad from 'react-lazyload'

const EventoCard = ({ evento }) => {
  const descrizione = evento.descrizione ? '- ' + evento.descrizione : ''

  return (
    <article className="evento-card">
      <header>
        <span className="evento-card__title">{evento.titolo}</span>
        {descrizione}
      </header>
      <main className="u-stylish-scroll u-stylish-scroll--blue">
        {evento.relatori.map(r => (
          <article key={r.id}>
            <figure className="evento-card__image-wrapper">
              {r.avatar ? (
                <LazyLoad height={65} offset={100} once>
                  <img
                    src={r.avatar}
                    alt={r?.toAltTitle()}
                    title={r?.toAltTitle()}
                    className="evento-card__image"
                  />
                </LazyLoad>
              ) : (
                <Icon classes="evento-card__default-image" id="user" />
              )}
            </figure>
            <section>
              <p>{r.descrizione}</p>
              <h4>{r.titolo}</h4>
            </section>
          </article>
        ))}
      </main>
    </article>
  )
}

export default EventoCard
